import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '影视热榜', href: '#ranking' },
  { label: '常见问题', href: '#faq' },
  { label: '热门话题', href: '#topics' },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header navItems={navItems} />
      <main>
        <Hero />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <FaqSection />
        <ContactSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
        <FeaturesSection />
        <AppSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}